export interface TSeparator {
  text?: string
  height?: string
  width?: string
  // gets converted to css class
  alignment?: string
  backgroundColor?: string
  border?: string
  borderTop?: string
  borderBottom?: string
  borderLeft?: string
  borderRight?: string
  margin?: string
  marginLeft?: string
  marginRight?: string
  lineHeight?: string
}

export type TSeparatorColors = 'primary' | 'warning' | 'danger' | 'success' | 'black' | 'grey'

export type TSeparatorColorsStyles = {
  name: TSeparatorColors
  value: string
}

export const SeparatorColors: TSeparatorColorsStyles[] = [
  { name: 'primary', value: 'var(--color-primary-main)' },
  { name: 'warning', value: 'var(--color-warning-main)' },
  { name: 'danger', value: 'var(--color-danger-light)' },
  { name: 'success', value: 'var(--color-success-main)' },
  { name: 'black', value: 'var(--color-black)' },
  { name: 'grey', value: 'var(--color-gray-200)' },
]

export type TSeparatorHeight = 'xxl' | 'xl' | 'lg' | 'base' | 'sm' | 'xs'

export type TSeparatorHeightStyles = {
  name: TSeparatorHeight
  value: string
}

export const SeparatorHeight: TSeparatorHeightStyles[] = [
  { name: 'xxl', value: '6px' },
  { name: 'xl', value: '5px' },
  { name: 'lg', value: '4px' },
  { name: 'base', value: '3px' },
  { name: 'sm', value: '2px' },
  { name: 'xs', value: '1px' },
]

export type TSeparatorWidth = '25%' | '50%' | '75%' | '100%'

export type TSeparatorWidthStyles = {
  name: TSeparatorWidth
  value: string
}

export const SeparatorWidth: TSeparatorWidthStyles[] = [
  { name: '25%', value: 'RichTextEditor__separator--25' },
  { name: '50%', value: 'RichTextEditor__separator--50' },
  { name: '75%', value: 'RichTextEditor__separator--75' },
  { name: '100%', value: 'RichTextEditor__separator--100' },
]

export type TSeparatorAlignment = 'left' | 'right' | 'center'

export type TSeparatorAlignmentStyles = {
  name: TSeparatorAlignment
  value: string
}

export const SeparatorAlignment: TSeparatorAlignmentStyles[] = [
  { name: 'left', value: 'RichTextEditor__separator--left' },
  { name: 'right', value: 'RichTextEditor__separator--right' },
  { name: 'center', value: 'RichTextEditor__separator--center' },
]
